var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.gridConfiguration
        ? _c(_setup.Grid, {
            attrs: {
              gridConfiguration: _setup.gridConfiguration,
              itemData: _setup.contacts,
              toolbarOptions: _setup.toolbarOptions,
              toolbarClick: _setup.onToolbarClick,
              commandClick: _setup.onCommandClick,
              contextMenuItems: _setup.contextMenuItems,
              exportName: _setup.texts.exportName,
            },
            on: {
              rowClick: _setup.onRowClick,
              contextMenuClicked: _setup.onContextMenuClicked,
            },
          })
        : _vm._e(),
      _c(_setup.PromptDialog, {
        attrs: {
          title: _setup.parseModalTitle,
          isOpened: _setup.openedPrompt,
          context: _vm.context,
          formSchema: _setup.formSchema,
          formFieldValues: _setup.formData,
          width: _vm.modalWidth,
        },
        on: { "execute-action": _setup.onExecuteAction },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }